import {noop} from '@benchling/js-utils';
import {Edge} from 'reactflow';

import {makeReactContext} from 'lib/makeReactContext';

export interface ComplexPolymerDragAndDropCanvasContextPayload {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  edges: Array<Edge>;
}

const getDefaultContext = (): ComplexPolymerDragAndDropCanvasContextPayload => ({
  isEditing: false,
  setIsEditing: noop,
  edges: [],
});

export const ComplexPolymerDragAndDropCanvasContext =
  makeReactContext<ComplexPolymerDragAndDropCanvasContextPayload>(
    getDefaultContext,
    'ComplexPolymerDragAndDropCanvasContext'
  );

/**
 * A context for sharing information from the top-level complex polymer drag and drop renderer.
 */
export function useComplexPolymerDragAndDropCanvasContext(): ComplexPolymerDragAndDropCanvasContextPayload {
  return ComplexPolymerDragAndDropCanvasContext.useContext();
}
